export function limparFeedBack(){
    return {
        type: 'FEEDBACK_LIMPAR'
    }
}

export function setFeedBack({
    icon, 
    title, 
    description, 
    primaryAction, 
    primaryActionLabel, 
    secondaryAction,
    secondaryActionLabel, 
    noAction
}){
    return {
        type: 'SET_FEEDBACK',
        payload: {
            icon, 
            title, 
            description, 
            primaryAction, 
            primaryActionLabel, 
            secondaryAction,
            secondaryActionLabel, 
            noAction
        }
    }
}

export function triggerAction(id) {
    return {
        type: 'FEEDBACK_TRIGGER_ACTION',
        payload: id
    }
}